export default __webpack_public_path__ + "static/media/DSC4742.3dc9078b.jpg";